var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1733 19.1961L4.71246 11.0055L13.174 2.80253L13.3594 2.62283L13.1738 2.44334L11.496 0.820315L11.322 0.651988L11.1482 0.820502L0.825987 10.8273L0.6407 11.0069L0.826115 11.1864L11.149 21.1796L11.323 21.348L11.4969 21.1795L13.1734 19.5552L13.3588 19.3756L13.1733 19.1961Z",
    fill: "#3F46AD",
    stroke: "#3F46AD",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.2b591ff935dced852f756f1779c2a9fa.svg";
export { ForwardRef as ReactComponent };